<template>
  <div :class="{ 'sm:f-flex f-relative': singleColumn }">
    <label
      :id="id"
      v-if="label"
      v-bind="$attrs"
      :class="{ 'f-w-28': singleColumn }"
    >
      {{ label }}
    </label>
    <div v-if="!label" class="sm:f-w-32"></div>
    <div class="f-w-full">
      <slot name="input" />
      <slot name="error" />
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "BaseInputGroup",

  props: {
    id: {
      type: String,
    },
    label: {
      type: String,
    },
    error: {
      type: String,
      default: "",
    },
    singleColumn: {
      type: Boolean,
      default: false,
    },
  },
});
</script>
